module.exports = __webpack_public_path__ + "img/menu.742805dd.png";